import { DataTable, DataTableData } from "@/src/components/ui/data-table";
import { Location, LocationWithYachtCount } from "./model";
import { useEffect, useState } from "react";
import { usePageSize, useSearch } from "./state";
import { useNavigate } from "react-router-dom";
import { useFetch } from "@/src/lib/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import { extractFromMultiName } from "./utils";

export function LocationsTable() {
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState<DataTableData<LocationWithYachtCount>>({
    data: [],
    total: 1,
    pagination: { page: 1, pageSize: 1 },
  });
  const [page, setPage] = useState(1);

  const navigate = useNavigate();
  const search = useSearch();
  const pageSize = usePageSize();
  const { fetch } = useFetch();

  useEffect(() => {
    const fetchLocations = (page: number) =>
      fetch<DataTableData<LocationWithYachtCount>>(
        `/api/locations/locations?page=${page}&pageSize=${pageSize}&filter=${search}`,
      );
    setLoading(true);
    fetchLocations(page).then((data) => {
      setLocations(data);
      setLoading(false);
    });
  }, [page, search, pageSize]);

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-md bg-white border">
        <DataTable
          isLoading={loading}
          columns={locationsColumns}
          pagination={locations}
          data={locations.data}
          onPageClick={setPage}
          onRowClick={(r) => navigate(`/locations/${r.id}`)}
        />
      </div>
    </div>
  );
}

export const locationsColumns: ColumnDef<LocationWithYachtCount>[] = [
  {
    header: "Name",
    accessorFn: (l) => extractFromMultiName(l.names),
  },
  {
    header: "Coordinates",
    accessorFn: (l) => `${l.latitude.toFixed(6)}, ${l.longitude.toFixed(6)}`,
  },
  {
    header: "Town",
    accessorFn: (l) => extractFromMultiName(l.town.names, "N/A"),
  },
  {
    header: "Country",
    accessorFn: (l) => extractFromMultiName(l.town?.country?.names, "N/A"),
  },
  {
    header: "Yacht count",
    accessorKey: "yachtCount",
  },
];
